let t = "http://img.fengbolive.com/pic/avatar/{0}_{1}_200*200.jpg"
const state = {
    anchorList: [],
    anchorInfoMap: {},
}
const mutations = {
    FAMILY_UPDATA_ANCHOR_LIST(state, data) {
        if (null == data) {
            state.anchorList = [];
            return;
        }
        let lsSrc = data;
        let info, url = null;
        for (let i = 0; i < lsSrc.length; i++) {
            // console.log("FAMILY_UPDATA_ANCHOR_LIST", lsSrc.length, lsSrc[i]);
            info = lsSrc[i];
            url = info.aurl;
            if (info.phid == 0) {
                info['img'] = "\\\\static/face/default.png";
            } else {
                info['img'] = t.format(info.id, info.phid);
                info['pnum'] = info.phid;
                info['uid'] = info.id;
            }
            info['name'] = decodeURI(info.name)
            if (url.indexOf('hdlws.sinashow.com') > 0) {
                //var state = 0;
                info['url'] = url.replace('hdlws.sinashow.com', 'hlsws.sinashow.com').replace('.flv', '/playlist.m3u8');
            } else if (url.indexOf('hdlnew.sinashow.com') > 0) {
                info['url'] = url.replace('hdlnew.sinashow.com', 'hlsws.sinashow.com').replace('.flv', '/playlist.m3u8');
            } else {
                //var state = 1;
                info['url'] = url.replace('hdlks.sinashow.com', 'hlsks.sinashow.com').replace('.flv', '/index.m3u8');
            }
            info.id = info.id.toString();
            state.anchorList.push(info);
            //将数据存入映射当中
            state.anchorInfoMap[info.id] = info
        }
        // console.log("FAMILY_UPDATA_ANCHOR_LIST state.anchorList", state.anchorList);
    }
}

const actions = {

}

const getters = {
    getAnchorInfoByIDFromFamilyList: (state) => (id) => {
        let b = state.anchorInfoMap[id];
        if (b == null) {
            b = state.anchorList.find((e) => (e.id == id))
        }
        return b
    },
    getAnchorSeverInfoByIDFromFamilyList: (state) => (id) => {
        let anchorInfo = state.anchorInfoMap[id];
        if (!anchorInfo) {
            return null;
        }
        let sInfo = state.anchorInfo.ip;
        for (let index = 0; index < sInfo.length; index++) {
            const element = sInfo[index];
            if (element.isp == 3) {
                return sInfo[index];
            }

        }
        return sInfo[0];
    },
}

export default {
    state,
    mutations,
    actions,
    getters
}